import React from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Button, 
  Container,
  Divider,
  useTheme
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';

const ThankYou = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  
  return (
    <Container maxWidth="md">
      <Paper 
        elevation={3} 
        sx={{ 
          p: { xs: 3, sm: 5 }, 
          mt: 4, 
          textAlign: 'center',
          borderRadius: 3,
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
        }}
      >
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            mb: 4
          }}
        >
          <CheckCircleIcon 
            sx={{ 
              fontSize: 80, 
              color: 'success.main',
              mb: 2
            }} 
          />
          
          <Typography 
            variant="h4" 
            component="h1" 
            gutterBottom
            sx={{ 
              fontWeight: 'bold',
              color: 'primary.main'
            }}
          >
            Registration Complete!
          </Typography>
          
          <Typography 
            variant="subtitle1" 
            color="text.secondary"
            sx={{ maxWidth: '80%', mx: 'auto', mb: 3 }}
          >
            Thank you for registering for WONCA SAR 2025. Your registration has been successfully submitted.
          </Typography>
          
          <Divider sx={{ width: '50%', my: 3 }} />
          
          <Box 
            sx={{ 
              bgcolor: 'primary.light', 
              color: 'primary.contrastText',
              p: 3,
              borderRadius: 2,
              width: '100%',
              maxWidth: 500,
              mb: 3
            }}
          >
            <Typography variant="h6" gutterBottom>
              What's Next?
            </Typography>
            
            <Typography variant="body1" paragraph align="left">
              1. You will receive a confirmation email shortly with your registration details.
            </Typography>
            
            <Typography variant="body1" paragraph align="left">
              2. Please visit the registration desk at the venue to make your payment and collect your badge.
            </Typography>
            
            <Typography variant="body1" align="left">
              3. Once payment is confirmed, you will receive your official registration confirmation.
            </Typography>
          </Box>
          
          
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<HomeIcon />}
            onClick={() => navigate('/')}
            sx={{ 
              px: 4, 
              py: 1.5, 
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 'bold',
              boxShadow: 3
            }}
          >
            Return to Homepage
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default ThankYou; 